
const NoBonusCode = () => {
    return (
        <div className="no-payments">
            <h3>
                Бонус сюди! Використай його, доки ми не передумали! <span>😆</span>
            </h3>
            <p>
                Періодично ми викладаємо їх у нашому Discord
            </p>
        </div>
    );
};

export default NoBonusCode;